import { createContext } from 'react'

/**
 * This context is useful when there is a need to access the motion value
 * while rendering components via the `text` prop.
 */
const MotionValueContext = createContext({})
export default MotionValueContext
